// webadmin gives every published faculty member a display order — the `order`
// on their published record — and the directory is simply sorted by it.
//
// webadmin numbers people within a department (every department runs 1…n), so
// the same number can appear once per department; across departments those
// simply tie.

/**
 * Sort by display order, lowest first.
 *
 * Nothing but the number is consulted. Anyone without one (nobody published
 * them, or the record carries no usable number) goes after everyone who has
 * one, and equal numbers keep their current order — so people the sort has
 * nothing to say about stay in the order they were already in.
 */
export function sortByDisplayOrder<T extends { displayOrder?: number }>(items: readonly T[]): T[] {
  const rank = (item: T) => {
    const n = item.displayOrder;
    return n !== undefined && Number.isFinite(n) ? n : Infinity;
  };
  return items
    .map((item, at) => ({ item, at, rank: rank(item) }))
    .sort((a, b) => (a.rank === b.rank ? a.at - b.at : a.rank < b.rank ? -1 : 1))
    .map((e) => e.item);
}
